<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
    >
        <Modulo :data="{form, model}" />
    </rkm-form>
</template>

<script>
// Components.
import Modulo from './components/modulo/Index'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {Modulo},
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('painelSenha.parametrizacao'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.setLoading()

            const request = { 
                infraestruturas: this.model.infraestruturas.map(infraestrutura => {
                    return {
                        id: infraestrutura.id,
                        modulos: infraestrutura.modulos.map(modulo => modulo.id),
                    }
                })
            }

            this.repositories.parametrizacao.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.showSaveNotification()
                    this.$emit('saved', response)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
}
</script>